var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    !_vm.loading
      ? _c("div", { staticClass: "main-lmd-dashboard" }, [
          _c(
            "div",
            { staticClass: "graph-container" },
            [
              _c(
                "el-row",
                { attrs: { type: "flex", gutter: 12 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 24, md: 10 } },
                    [
                      _c(
                        "el-row",
                        { attrs: { type: "flex", gutter: 12 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24, xs: 24 } },
                            [
                              _c(
                                "el-card",
                                {
                                  staticClass: "min-vh-150px",
                                  attrs: { shadow: "always" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "clearfix",
                                      attrs: { slot: "header" },
                                      slot: "header",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("dashboard.filter"))
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c("el-date-picker", {
                                    staticClass: "w-100",
                                    attrs: {
                                      type: "date",
                                      clearable: false,
                                      placeholder: _vm.$t("dateRange.date"),
                                      "value-format": "yyyy-MM-dd",
                                      "picker-options": { firstDayOfWeek: 7 },
                                    },
                                    on: { change: _vm.handlePlanDateChanges },
                                    model: {
                                      value: _vm.$planDate,
                                      callback: function ($$v) {
                                        _vm.$planDate = $$v
                                      },
                                      expression: "$planDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8, xs: 24 } },
                            [
                              _c(
                                "el-card",
                                {
                                  staticClass: "min-vh-150px number-count-card",
                                  attrs: { shadow: "always" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "clearfix",
                                      attrs: { slot: "header" },
                                      slot: "header",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "dashboard.unassignedJobOrderWeight"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c("number-count", {
                                    attrs: {
                                      number: _vm.helper.get(
                                        _vm.summaryData,
                                        "weight",
                                        0
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8, xs: 24 } },
                            [
                              _c(
                                "el-card",
                                {
                                  staticClass: "min-vh-150px number-count-card",
                                  attrs: { shadow: "always" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "clearfix",
                                      staticStyle: { "min-height": "48px" },
                                      attrs: { slot: "header" },
                                      slot: "header",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "dashboard.unassignedJobOrderVolume"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c("number-count", {
                                    attrs: {
                                      number: _vm.helper.get(
                                        _vm.summaryData,
                                        "volume",
                                        0
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8, xs: 24 } },
                            [
                              _c(
                                "el-card",
                                {
                                  staticClass: "min-vh-150px number-count-card",
                                  attrs: { shadow: "always" },
                                },
                                [
                                  _vm.hasAssemblyMinutes
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "clearfix",
                                            attrs: { slot: "header" },
                                            slot: "header",
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "dashboard.unassignedJobOrderAssemblyMinutes"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c("number-count", {
                                          attrs: {
                                            number: _vm.helper.get(
                                              _vm.summaryData,
                                              "assemblyMinutes",
                                              0
                                            ),
                                          },
                                        }),
                                      ]
                                    : [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "clearfix",
                                            staticStyle: {
                                              "min-height": "48px",
                                            },
                                            attrs: { slot: "header" },
                                            slot: "header",
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "dashboard.unassignedJobOrderQuantity"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c("number-count", {
                                          attrs: {
                                            number: _vm.helper.get(
                                              _vm.summaryData,
                                              "quantity",
                                              0
                                            ),
                                          },
                                        }),
                                      ],
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8, xs: 24 } },
                            [
                              _c(
                                "el-card",
                                {
                                  staticClass: "min-vh-150px number-count-card",
                                  attrs: { shadow: "always" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "clearfix",
                                      attrs: { slot: "header" },
                                      slot: "header",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "dashboard.unassignedJobOrderCount"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c("number-count", {
                                    attrs: {
                                      number: _vm.helper.get(
                                        _vm.summaryData,
                                        "count",
                                        0
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8, xs: 24 } },
                            [
                              _c(
                                "el-card",
                                {
                                  staticClass: "min-vh-150px number-count-card",
                                  attrs: { shadow: "always" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "clearfix",
                                      attrs: { slot: "header" },
                                      slot: "header",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "dashboard.availableOrderCount"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c("number-count", {
                                    attrs: {
                                      number: _vm.helper.get(
                                        _vm.dashboardData,
                                        "availableOrder",
                                        0
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8, xs: 24 } },
                            [
                              _c(
                                "el-card",
                                {
                                  staticClass: "min-vh-150px number-count-card",
                                  attrs: { shadow: "always" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "clearfix",
                                      attrs: { slot: "header" },
                                      slot: "header",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "dashboard.completedOrderCount"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c("number-count", {
                                    attrs: {
                                      number: _vm.helper.get(
                                        _vm.dashboardData,
                                        "completedOrder",
                                        0
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 24, md: 14 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "min-vh-300px",
                          attrs: { shadow: "always" },
                        },
                        [
                          _c("map-world", {
                            ref: "markMap",
                            attrs: {
                              locations: _vm.locations,
                              routes: _vm.selectedLatlng,
                              "init-event": "marker",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "gantt-chart-container" },
            [
              _c(
                "el-card",
                { staticClass: "min-vh-150px", attrs: { shadow: "always" } },
                [
                  _c("mini-gantt-chart", {
                    attrs: {
                      routing: _vm.routingData,
                      date: _vm.$planDate,
                      allCompany: false,
                      "selected-values": _vm.selectedValues,
                      defaultDaysOfIncrement: _vm.ganttDOI,
                      defaultDate: _vm.ganttDate,
                    },
                    on: { selectedFunction: _vm.updateMarker },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }